<script setup lang="ts"></script>

<template>
  <div
    title="Freqtrade logo"
    class="mx-auto dark:bg-white bg-black transition-all duration-300 mask-[url(@/assets/freqtrade-logo-mask.png)] mask-no-repeat mask-contain mask-center"
  />
</template>
